import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { toggleModalInviteRevoke } from '../../../redux/main/main.actions';
import { selectIsModalInviteRevokeEnabled, selectModalInviteRevokeData } from '../../../redux/main/main.selectors';
import { selectCurrentWorkspace } from '../../../redux/workspace/workspace.selectors';
import { workspaceRevokeInviteRequest } from '../../../redux/workspace/workspace.actions';

import { trackEvent } from '../../../lib/analytics';

import Modal from '../Modal/Modal';
import './ModalInviteRevoke.scss';

export const ModalInviteRevoke = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const isOpen = useSelector(selectIsModalInviteRevokeEnabled);
    const modalData = useSelector(selectModalInviteRevokeData);
    const workspace = useSelector(selectCurrentWorkspace);

    const [invite, setInvite] = useState(null);
    const [label, setLabel] = useState('');

    useEffect(() => {
        setInvite(modalData?.invite || null);

        const next = modalData?.invite?.email;
        if (!next) return;

        if (label !== next) {
            setLabel(next);
        }

        return () => { };
    }, [modalData]);

    const reset = () => {
        setInvite(null);
        setLabel('');
    };

    const handleCancel = () => {
        dispatch(toggleModalInviteRevoke(null));
        setTimeout(reset, 300);
    };

    const handleRevoke = () => {
        const inviteId = invite?.id;
        if (!inviteId || !workspace?.id) return;
        trackEvent('app_modal_invite_revoke_submit', {
            page: 'app',
            type: 'modals',
        });
        dispatch(workspaceRevokeInviteRequest({ workspaceId: workspace.id, inviteId }));
        dispatch(toggleModalInviteRevoke(null));
        setTimeout(reset, 300);
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass="modal-invite-revoke"
            onCancel={handleCancel}
        >
            <div className="modal-content-header">{t('m_invite_revoke.header')}</div>
            <div className="modal-content-body">
                <div className="description-text">
                    {t('m_invite_revoke.desc_prefix')}<span className="text-title-bold">{label}</span>?
                    {t('m_invite_revoke.desc_suffix')}
                </div>
                <div className="buttons-wrap">
                    <button className="button-second" onClick={handleCancel}>{t('b.cancel')}</button>
                    <button className="" onClick={handleRevoke}>{t('b.remove')}</button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalInviteRevoke;
